import { Agent } from "./agent";
import { AgentSource } from "./codebooks/agent-source";
import { UserRole } from "./codebooks/user-role";

export class User {
  authenticated: boolean;
  firstName: string;
  lastName: string;
  locale?: string;
  prefferedAgent?: Agent;
  lastLogin: string;
  SetPrefferedAgentPopup?: boolean;
  agentSource: AgentSource;
  role: UserRole;
  vatNumber?: string;
  isAdmin: boolean;
  profileUrl: string;
}
